import React, { Fragment } from 'react';

const About = () =>
{
    return(
        <Fragment>
          <h1> About this app</h1>
          <p>App for searching Github user</p>
          <p>Version 1.0.0</p>  
        </Fragment>
    )
}
export default About;